var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_74_454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8272 57.0076C16.9239 57.0076 13.0142 56.9066 9.11502 57.0328C3.90147 57.2011 -0.487999 53.1174 0.046081 47.0645C0.897272 37.4181 7.33962 29.9029 16.6735 27.8095C27.8955 25.2932 39.5367 33.206 41.4269 44.6324C41.7503 46.5869 41.9881 48.5498 41.5249 50.5044C40.6028 54.3945 37.2481 56.976 33.086 57.0013C28.9991 57.0265 24.9121 57.0076 20.8272 57.0076ZM20.8752 51.9582C24.6221 51.9582 28.3732 51.8488 32.1139 51.9897C35.5645 52.1202 37.1584 50.4244 36.7057 46.73C35.5896 37.6158 27.6827 31.4156 18.6304 32.5959C11.1595 33.57 5.17409 40.3236 5.02596 47.9439C4.97589 50.5233 6.36534 51.9561 8.93351 51.9582C12.9141 51.9624 16.8946 51.9582 20.8752 51.9582Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.008 57.0223C52.7694 57.0223 50.5309 57.0349 48.2923 57.0181C46.978 57.0076 46.0162 56.2943 45.6991 55.154C45.3027 53.7234 46.2374 52.3116 47.7854 52.0318C48.115 51.9729 48.4592 51.975 48.7972 51.975C52.9092 51.9708 57.0212 51.975 61.1332 51.9708C63.6346 51.9687 65.0449 50.5065 64.999 47.9818C64.8488 39.6061 57.9413 32.6127 49.6609 32.436C47.8751 32.3981 46.1372 32.6085 44.4265 33.1387C43.9655 33.2818 43.4502 33.3659 42.9724 33.3217C41.8041 33.2123 40.932 32.3076 40.8006 31.1863C40.6608 30.0018 41.3263 28.9035 42.5113 28.4933C47.0302 26.9258 51.5636 26.9974 56.0595 28.5564C64.2376 31.3882 69.8913 39.3389 69.9977 48.0702C70.0603 53.1932 66.4135 56.9676 61.3293 57.0202C59.2222 57.0412 57.113 57.0244 55.0038 57.0244L55.008 57.0223Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.4707 11.7861C37.4728 5.28293 42.7072 -0.00840562 49.1328 1.00246e-05C55.5606 0.00842567 60.7908 5.30397 60.7887 11.8008C60.7846 18.2914 55.5314 23.5996 49.1182 23.5912C42.6884 23.5828 37.4728 18.2935 37.4728 11.784L37.4707 11.7861ZM42.4714 11.824C42.4861 15.529 45.4798 18.546 49.1328 18.5397C52.813 18.5334 55.813 15.4617 55.788 11.7251C55.763 8.04116 52.7129 5.00732 49.0765 5.0515C45.3943 5.09568 42.4568 8.10848 42.4714 11.8219V11.824Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5523 11.8324C32.5293 18.3419 27.2907 23.6122 20.863 23.5932C14.4186 23.5743 9.2092 18.2346 9.2384 11.6788C9.26552 5.25135 14.5604 -0.0315706 20.9381 -1.19263e-05C27.3825 0.0315467 32.5752 5.32288 32.5523 11.8324ZM27.5515 11.8324C27.5703 8.11477 24.6454 5.11039 20.9548 5.05569C17.3268 5.00099 14.2642 8.03903 14.2371 11.7209C14.2099 15.4574 17.2037 18.5312 20.8839 18.5439C24.5411 18.5544 27.5327 15.5458 27.5536 11.8345L27.5515 11.8324Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 57.037,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cee5cf575bfc38ba9b3498d4e1259119.svg";
export { ForwardRef as ReactComponent };